import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=40ebb09f&"
import script from "./PhonePreview.vue?vue&type=script&lang=js&"
export * from "./PhonePreview.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&id=40ebb09f&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports